import { Location } from "@angular/common";
import { Component, inject, Input } from "@angular/core";

@Component({
  selector: "mobi-office-lib-back-arrow",
  templateUrl: "./back-arrow.component.html",
  styleUrls: ["./back-arrow.component.scss"],
  standalone: false,
})
export class BackArrowComponent {
  private readonly location = inject(Location);

  constructor() {}

  @Input() matIconName: string = "arrow_back";
  @Input() matIconToolTip: string = "Go Back";

  goBack() {
    this.location.back();
  }
}
